// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6816":"9bc7bae2d3f03059","9430":"b9d0d0c775165851"}[chunkId] + ".js";
};